import { useState } from "react";

const useLocalStorage = (
    key: string,
    initialValue: string,
): [string | Record<string, unknown>, (v: string) => void] => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    });

    const setValue = (valueToStore: string) => {
        try {
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            throw Error((error as Error).message);
        }
    };

    return [storedValue, setValue];
};
export default useLocalStorage;
